import i18next from 'i18next';

i18next.addResources('en', 'AdelphiMashingAndFermentationTotalsModal', {
  totalsTitle: 'Totals',
  tones: 'Tonnes',
  distilamax: 'Yeast - Distilamax MW',
  fermentis: 'Yeast - Fermentis',
  safspiritM1: 'Yeast - Safspirit M-1',
  safspiritD53: 'Yeast - Safspirit D-53',
  wortVolume: 'Wort Volume',
  originalGravity: 'OG',
  finalGravity: 'FG',
  da: 'DA',
  mte: 'MTE',
  psy: 'PSY',
  alcoholAtt: 'Alcohol Att'
});
